import { render, staticRenderFns } from "./socioFormDocumentDialog.vue?vue&type=template&id=a5573586"
import script from "./socioFormDocumentDialog.vue?vue&type=script&lang=js"
export * from "./socioFormDocumentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports